import api from '../utils/api';
import { Plan, Payment, Subscription } from '../types/payment';

export const getPlans = async (): Promise<Plan[]> => {
  const res = await api.get('/plans');
  return res.data;
};

export const createCheckoutSession = async (
  planId: string,
): Promise<{ url?: string; manualMode?: boolean; message?: string; subscriptionId?: string }> => {
  const res = await api.post('/subscriptions/create-checkout-session', {
    planId,
  });
  return res.data;
};

export const cancelUserSubscription = async (
  userId: string,
  reason?: string,
): Promise<{ success: boolean; message: string }> => {
  const res = await api.post(`/subscriptions/cancel/${userId}`, { reason });
  return res.data;
};

export const getUserPaymentHistory = async (userId: string): Promise<Record<string, unknown>> => {
  const res = await api.get(`/subscriptions/user/${userId}/history`);
  return res.data;
};

export const getAllPayments = async (filters?: {
  search?: string;
  status?: string;
  startDate?: string;
  endDate?: string;
  page?: number;
  limit?: number;
}): Promise<{ data: Payment[]; total: number; page: number; limit: number }> => {
  const params = new URLSearchParams();
  if (filters?.search) params.append('search', filters.search);
  if (filters?.status) params.append('status', filters.status);
  if (filters?.startDate) params.append('startDate', filters.startDate);
  if (filters?.endDate) params.append('endDate', filters.endDate);
  if (filters?.page) params.append('page', filters.page.toString());
  if (filters?.limit) params.append('limit', filters.limit.toString());

  const res = await api.get(`/subscriptions/payments/all?${params.toString()}`);
  return res.data;
};

export const getAllSubscriptions = async (filters?: {
  search?: string;
  status?: string;
  page?: number;
  limit?: number;
}): Promise<{ data: Subscription[]; total: number; page: number; limit: number }> => {
  const params = new URLSearchParams();
  if (filters?.search) params.append('search', filters.search);
  if (filters?.status) params.append('status', filters.status);
  if (filters?.page) params.append('page', filters.page.toString());
  if (filters?.limit) params.append('limit', filters.limit.toString());

  const res = await api.get(`/subscriptions/all?${params.toString()}`);
  return res.data;
};
